import {$controller} from "rapid/index";

const dependencies = ["$search", "CONFIG"];

export class SidebarController extends $controller {

	constructor($injector) {
		"ngInject";
		super($injector, dependencies);

		this.badges = [];

		this.$rootScope.$on("$watchCollection", (e, data) => {


			if (data.uri.indexOf("company-requests") !== -1) {
				this.$rootScope.$apply(() => {
					this.updateBadge(data.uri);
				});
			}
		});

		this.$rootScope.$on("updateBadge", (e, uri) =>
			this.updateBadge(uri)
		);
	}

	$onInit(){

		const count = ( key ) => this.$search
			.$search(this.CONFIG.API[key], {filter: {status: "pending"}})
			.then(data => {
				this.badges[this.CONFIG.API[key]] = data.objects.filter((o) => { return o.status == "pending"; }).length;
			});

		this.$getDataBeforeRun([
			count("CreateCompanyRequests"),
			count("PortalAddCompanyRequests")
		]);

	}

	updateBadge(uri) {
		this.badges[uri] = this.$getCollection(uri).filter((o) => { return o.status == "pending"; }).length;
	}

	isAuthenticated() {
		return this.$auth.isAuthenticated();
	}

	logout() {
		return this.$auth.logout();
	}
}

export default SidebarController;



// WEBPACK FOOTER //
// ./sources/components/layout/sidebar/sidebar.controller.js